import React from "react";
import {css} from "@emotion/react";

import {InputRange, IRange} from "@pg-design/inputs-module";

import {ISearchFilter} from "../../types/ISearchFilters";

interface IProps {
    filter: ISearchFilter<string, number>;
    value: IRange<string>;
    onChange: (name: string, value: IRange<string>) => void;
    currency?: boolean;
}

export const FilterRange = (props: IProps) => {
    return (
        <InputRange
            name={props.filter.id}
            value={props.value}
            hasDashSeparator
            roundToMultiplicationOf={5}
            errorOnBottom
            onChange={(name, value) => {
                props.onChange(name, value as IRange<string>);
            }}
            options={props.filter.filterOptions}
            css={rangeFilterStyleAdjustment(props.value, props.filter.id, props.currency)}
        />
    );
};

const rangeFilterStyleAdjustment = (value: IRange<string>, name: string, currency?: boolean) => css`
    .range-input-lower,
    .range-input-upper {
        margin-bottom: 10px;
        position: relative;

        & > div {
            flex: 1 1;
        }
    }

    .range-input-lower {
        ${currency && Number(value.lower) > 0 && name === "price"
            ? `
        &:after {
            content: "eur";
            position: absolute;
            top: 50%;
            right: 0;
            transform: translate(-5rem, -50%);
        }
        `
            : ""}
    }
    .range-input-upper {
        ${currency && Number(value.upper) > 0 && name === "price"
            ? `
        &:after {
            content: "eur";
            position: absolute;
            top: 50%;
            right: 0;
            transform: translate(-5rem, -50%);
        }
        `
            : ""}
    }
`;
import React from "react";
import {css} from "@emotion/react";

import {InputRange, IRange} from "@pg-design/inputs-module";

import {ISearchFilter} from "../../types/ISearchFilters";

interface IProps {
    filter: ISearchFilter<string, number>;
    value: IRange<string>;
    onChange: (name: string, value: IRange<string>) => void;
    currency?: boolean;
}

export const FilterRange = (props: IProps) => {
    return (
        <InputRange
            name={props.filter.id}
            value={props.value}
            hasDashSeparator
            roundToMultiplicationOf={5}
            errorOnBottom
            onChange={(name, value) => {
                props.onChange(name, value as IRange<string>);
            }}
            options={props.filter.filterOptions}
            css={rangeFilterStyleAdjustment(props.value, props.filter.id, props.currency)}
        />
    );
};

const rangeFilterStyleAdjustment = (value: IRange<string>, name: string, currency?: boolean) => css`
    .range-input-lower,
    .range-input-upper {
        margin-bottom: 10px;
        position: relative;

        & > div {
            flex: 1 1;
        }
    }

    .range-input-lower {
        ${currency && Number(value.lower) > 0 && name === "price"
            ? `
        &:after {
            content: "eur";
            position: absolute;
            top: 50%;
            right: 0;
            transform: translate(-5rem, -50%);
        }
        `
            : ""}
    }
    .range-input-upper {
        ${currency && Number(value.upper) > 0 && name === "price"
            ? `
        &:after {
            content: "eur";
            position: absolute;
            top: 50%;
            right: 0;
            transform: translate(-5rem, -50%);
        }
        `
            : ""}
    }
`;
